import MessageService from '../MessageService';
import Test from '../Test';

export default class QuitTestButton {
    /**
     * QuitTestButton constructor
     * @param {MessageService} messageService
     * @param {Test} test
     */
    constructor(messageService, test) {
        this.messageService = messageService;
        this.test = test;
    }
    init() {
        document.querySelectorAll('.quit-from-test').forEach((btn) => {
            btn.addEventListener('click', (e) => {
                if (confirm(this.messageService.uiMessages.dc_quit_from_test_confirmation)) {
                    this.test.onCloseTest(e);
                }
            });
        });
    }
}
